import Vue from 'vue';
import Router from 'vue-router';


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/topup/:secret',
      name: 'topup',
      component: () => import('./views/TopUp.vue')
    },
    {
      path: '/pay/:secret',
      name: 'pay',
      component: () => import('./views/TopUp.vue')
    },
    {
      path: '/auth/:application/:client',
      name: 'auth-redirect',
      component: () => import('./views/AuthRedirect.vue')
    },
    {
      path: '/signin',
      name: 'signin',
      component: () => import('./views/SignInMain.vue')
    },
    {
      path: '/single-signon',
      name: 'single-signon',
      component: () => import('./views/SingleSignOn.vue')
    },
    {
      path: '/legaldocflow/signin',
      name: 'legaldocflow-signin',
      component: () => import('./views/LegaldocflowSignIn.vue')
    },
    {
      path: '/playground',
      name: 'playground',
      component: () => import('./views/Playground.vue')
    },
    {
      path: '/oil-wells',
      name: 'PlaygroundGoogleMap',
      component: () => import('./views/PlaygroundGoogleMap.vue')
    },
    {
      path: '/orr',
      name: 'PlaygroundORR',
      component: () => import('./views/PlaygroundORR.vue')
    },
    {
      path: '/workflow',
      name: 'workflow',
      component: () => import('./views/Workflow.vue')
    },
    {
      path: '/merchant-workflow',
      name: 'merchant-workflow',
      component: () => import('./views/MerchantWorkflow.vue')
    },
    {
      path: '/template/:id',
      name: 'template',
      component: () => import('./views/Template.vue')
    },
    {
      path: '/template',
      name: 'new-template',
      component: () => import('./views/Template.vue')
    },
    {
      path: '/signature/:id',
      name: 'signature',
      component: () => import('./views/Signature.vue')
    },
    {
      path: '/service',
      name: 'service',
      component: () => import('./views/Service.vue')
    },
    {
      path: '/dashboard-layout/:projectId',
      name: 'dashboard-layout',
      component: () => import('./components/DashboardLayout.vue')
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./views/SignUp.vue')
    },
    {
      path: '/form/:id',
      name: 'form',
      component: () => import('./views/Form.vue')
    },
    {
      path: '/project/:projectId',
      name: 'project',
      meta: { requiresAuth: true},
      component: () => import('./components/Project.vue'),
      children: [
        {
          path: 'datasources',
          name: 'datasources',
          meta: { requiresAuth: true},
          component: () => import('./views/DataSources.vue')
        },
        {
          path: 'datasources/:dashboardId',
          name: 'datasources-id',
          meta: { requiresAuth: true},
          component: () => import('./views/DataSources.vue')
        },
        {
          path: 'charts',
          name: 'charts',
          meta: { requiresAuth: true},
          component: () => import('./views/Charts.vue')
        },
        {
          path: 'connections',
          name: 'connections',
          meta: { requiresAuth: true},
          component: () => import('./views/Connections.vue')
        },
        {
          path: 'boards',
          name: 'boards',
          meta: { requiresAuth: true},
          component: () => import('./views/Boards.vue')
        },
        {
          path: 'boards/:dashboardId',
          name: 'board-dashboard',
          meta: { requiresAuth: true},
          component: () => import('./views/Boards.vue')
        }
      ]
    },
    {
      path: '/dashboard/:projectId',
      name: 'dashboard',
      meta: { requiresAuth: true},
      component: () => import('./views/Dashboards.vue')
    },
    {
      path: '/dashboard/:projectId/:dashboardId',
      name: 'dashboard-id',
      meta: { requiresAuth: true},
      component: () => import('./views/Dashboards.vue')
    },
    {
      path: '/',
      meta: { requiresAuth: true},
      component: () => import('./views/Home.vue'),
      children: [
        {
          path: '/about',
          name: 'about',
          meta: { requiresAuth: true},
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
          path: '/drag-drop',
          name: 'drag-drop',
          meta: { requiresAuth: true},
          component: () => import('./views/DragDrop.vue')
        },
        {
          path: '/',
          name: 'projects-home',
          meta: { requiresAuth: true},
          component: () => import('./views/Projects.vue')
        },
        {
          path: '/projects',
          name: 'projects',
          meta: { requiresAuth: true},
          component: () => import('./views/Projects.vue')
        },

        {
          path: '/datasourcess/:projectId',
          name: 'datasources-old',
          meta: { requiresAuth: true},
          component: () => import('./views/DataSources.vue')
        }
      ]
   }
  ]
})
